import { createSlice } from '@reduxjs/toolkit';
import {
  createPickupPoint,
  deletePickupPoint,
  fetchPickupPoints,
  updatePickupPoint,
} from './pickupPointsThunks';

const initialState = {
  /** Every live point of the operator, by name. */
  items: [],
  loading: false,
  /** Whether the list has answered once: the order detail asks for it lazily. */
  loaded: false,
  error: null,
  /** The id being deleted, to disable only its row. */
  deletingId: null,
};

const pickupPointsSlice = createSlice({
  name: 'pickupPoints',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPickupPoints.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPickupPoints.fulfilled, (state, action) => {
        state.loading = false;
        state.loaded = true;
        state.items = action.payload;
      })
      .addCase(fetchPickupPoints.rejected, (state, action) => {
        state.loading = false;
        state.loaded = true;
        state.error = action.payload;
      })

      .addCase(createPickupPoint.fulfilled, (state, action) => {
        state.items = [...state.items, action.payload].sort((a, b) => a.name.localeCompare(b.name));
      })
      .addCase(updatePickupPoint.fulfilled, (state, action) => {
        state.items = state.items
          .map((row) => (row.id === action.payload.id ? action.payload : row))
          .sort((a, b) => a.name.localeCompare(b.name));
      })

      .addCase(deletePickupPoint.pending, (state, action) => {
        state.deletingId = action.meta.arg;
      })
      .addCase(deletePickupPoint.fulfilled, (state, action) => {
        state.deletingId = null;
        state.items = state.items.filter((row) => row.id !== action.payload);
      })
      .addCase(deletePickupPoint.rejected, (state) => {
        state.deletingId = null;
      });
  },
});

export const selectPickupPoints = (state) => state.pickupPoints.items;
export const selectPickupPointsLoaded = (state) => state.pickupPoints.loaded;

export default pickupPointsSlice.reducer;
